export enum UserStatus {
    Paired = 'paired',
    Pending = 'pending',
    Unpaired = 'unpaired',
    Excluded = 'excluded',
    Disabled = 'disabled',
    Unprotected = 'unprotected'
}
